/** Choix de la durée cible, du ratio et de la boucle de fond. */

import { cn } from '@jeraisonne/ui';
import { DURATION_OPTIONS } from '@jeraisonne/db/schemas/youtube';
import type { DurationSeconds, AspectRatio } from '@jeraisonne/db/schemas/youtube';
import { labelCls } from './ui';

interface DurationSettingsProps {
  duration: DurationSeconds;
  aspect: AspectRatio;
  loopBackground: boolean;
  onChange: (next: {
    duration?: DurationSeconds;
    aspect?: AspectRatio;
    loopBackground?: boolean;
  }) => void;
}

export function DurationSettings({
  duration,
  aspect,
  loopBackground,
  onChange,
}: DurationSettingsProps) {
  return (
    <div className="space-y-4">
      <div>
        <span className={labelCls}>Durée de la vidéo</span>
        <div className="mt-2 grid grid-cols-3 gap-2 sm:grid-cols-4">
          {DURATION_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange({ duration: opt.value as DurationSeconds })}
              className={cn(
                'h-11 rounded-xl border text-sm font-bold transition-colors active:scale-[.98]',
                duration === opt.value
                  ? 'border-primary-300 bg-primary-50 text-primary-700'
                  : 'border-ink-200 text-ink-600 bg-white',
              )}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-4">
        <div>
          <span className={labelCls}>Format</span>
          <div className="mt-2 flex gap-2">
            {(['landscape', 'portrait'] as const).map((a) => (
              <button
                key={a}
                type="button"
                onClick={() => onChange({ aspect: a })}
                className={cn(
                  'h-10 rounded-lg border px-3 text-xs font-bold transition-colors active:scale-[.98]',
                  aspect === a
                    ? 'border-primary-300 bg-primary-50 text-primary-700'
                    : 'border-ink-200 text-ink-600 bg-white',
                )}
              >
                {a === 'landscape' ? 'Paysage 16:9 (YouTube)' : 'Portrait 9:16 (Shorts/Reels)'}
              </button>
            ))}
          </div>
        </div>

        <label className="mt-5 inline-flex cursor-pointer items-center gap-2">
          <input
            type="checkbox"
            checked={loopBackground}
            onChange={(e) => onChange({ loopBackground: e.target.checked })}
            className="accent-primary-500 h-4 w-4"
          />
          <span className="text-ink-700 text-sm font-semibold">
            Boucler automatiquement le fond
          </span>
        </label>
      </div>
    </div>
  );
}
